export default {
  navHome: "홈",
  navProducts: "제품",
  navCases: "적용 사례",
  navAbout: "회사 소개",
  deliverTo: "배송지:",
  langCurrencyLabel: "한국어",
  localeLangTitle: "언어 설정",
  localeLangDesc: "선호하는 언어를 선택하세요. 언제든지 이 설정을 변경할 수 있습니다.",
  language: "언어",
  save: "저장",
  coreProducts: "현실 세계의 창작을 지원합니다.",
  coreProductsDesc: "아이디어에서 비즈니스까지 — YONGYUAN은 UV 프린터, 크리스탈 라벨 프린터, 고속 원통형 프린터, DTF 및 DTG 프린터를 제공하여 창의성을 제품, 브랜드, 기회로 전환합니다.",
  scenariosTitle: "모든 시나리오를 위한 솔루션",
  scenariosDesc: "브랜드를 구축하든, 부업을 개발하든, 창의적 열정을 추구하든 YONGYUAN은 귀하의 필요에 맞는 솔루션을 제공합니다.",
  scenarioStudio: "스튜디오",
  scenarioStudioDesc: "고부가가치 맞춤 제작, 소량 시제품 제작 및 브랜드 구축",
  scenarioRetail: "브랜드 리테일",
  scenarioRetailDesc: "고객 체류 시간 연장 및 매장 매출 증대",
  scenarioMarket: "팝업 마켓",
  scenarioMarketDesc: "현장 맞춤 제작, 완제품 판매 및 부수입",
  scenarioEnterprise: "기업 맞춤 제작",
  scenarioEnterpriseDesc: "대량 맞춤 제작, 브랜드 상품 및 기업 선물",
  scenarioEcommerce: "라이브 커머스",
  scenarioEcommerceDesc: "히트 상품 샘플링, 유연한 공급 및 빠른 신제품 출시",
  scenarioStore: "이커머스 스토어",
  scenarioStoreDesc: "스토어 맞춤 제작, 히트 상품 및 차별화된 운영",
  scenarioFactory: "공장 생산",
  scenarioFactoryDesc: "대량 생산, 안정적인 출력 및 비용 효율적 운영",
  scenarioAdvertising: "광고 제작",
  scenarioAdvertisingDesc: "간판, 디스플레이 자재 및 이벤트 자료",
  industries: "산업 응용",
  industriesDesc: "다양한 산업의 컬러 인쇄를 위한 디지털 잉크젯 인쇄 솔루션.",
  applicationsTitle: "일상 및 상업적 요구를 위한 다양한 소재와 색상 응용.",
  applicationsDesc: "YONGYUAN UV 인쇄 장비는 다양한 소재와 공정 시나리오에 맞게 설계되어 맞춤 제작과 대규모 생산을 지원합니다.",
  casesHeroDesc: "1200개 이상의 산업 응용과 수만 가지 인쇄 가능 소재를 지원하며, 다양한 비즈니스에 맞는 디지털 인쇄 솔루션을 제공합니다.",
  casesBreadcrumbHome: "홈",
  casesBreadcrumbCenter: "적용 사례",
  casesEmpty: "해당 분류의 적용 사례가 아직 없습니다.",
  customerStoriesTitle: "전 세계 고객의 신뢰",
  customerStoriesSubtitle: "172개국에서의 실제 설치, 실제 고객, 실제 인쇄 비즈니스.",
  customerStoriesStat1Value: "53,000+",
  customerStoriesStat1Label: "납품 대수",
  customerStoriesStat2Value: "172+",
  customerStoriesStat2Label: "서비스 국가",
  customerStoriesStat3Value: "23+",
  customerStoriesStat3Label: "업계 경험",
  customerStoriesStat4Value: "24/7",
  customerStoriesStat4Label: "기술 지원",
  customerStoriesPlaceholder: "고객 사진 추가",
  customerStoriesPhotoAlt: "YONGYUAN 고객과 프린터",
  servicePartnerTitle: "YONGYUAN 서비스 팀을 만나보세요, 귀하의 창의적 파트너",
  servicePartnerDesc: "장비 성능과 비즈니스 성장을 보호하는 글로벌 서비스 네트워크 및 전문 지원 시스템.",
  serviceSupportTitle: "표준 지원",
  serviceSupportDesc: "설치 안내, 기초 교육 및 일상 사용 지원으로 장비의 안정적인 운영을 보장합니다.",
  servicePresaleTitle: "판매 전 데모 및 상담",
  servicePresaleDesc: "응용 시나리오와 생산 능력 요구에 맞춘 솔루션 시연 및 모델 추천.",
  serviceLifetimeTitle: "평생 기술 지원",
  serviceLifetimeDesc: "장기적인 비즈니스 발전을 위한 지속적인 기술 대응 및 공정 지원.",
  serviceCareTitle: "YONGYUAN Care로 업그레이드",
  serviceCareDamageTitle: "우발적 손상 보호",
  serviceCareDamageDesc: "예기치 않은 사고로 인한 손실을 줄이기 위한 더 포괄적인 보호 계획.",
  serviceCareExchangeTitle: "빠른 교체 서비스",
  serviceCareExchangeDesc: "자격 조건 충족 시 우선 빠른 교체로 자본 회수를 가속화합니다.",
  viewProduct: "제품 보기",
  learnMore: "자세히 보기",
  catUv: "UV 플랫베드 프린터",
  catCylinder: "원통형 프린터",
  catCrystal: "크리스탈 라벨 프린터",
  catDtf: "DTF 프린터",
  catDtg: "DTG 프린터",
  companyName: "Shenzhen Yongyuan Technology Co., Ltd.",
  phone: "전화: 17748697567 탕 매니저",
  email: "이메일: sales@yongyuanprinter.com",
  copyright: "Copyright © 2012-2026 Shenzhen Yongyuan Technology Co., Ltd. All rights reserved",
  productsHeroTitle: "제품",
  productsHeroDesc: "다양한 생산 능력과 응용 요구를 위한 UV 플랫베드, 원통형, 크리스탈 라벨, DTF 및 DTG 장비 전 라인업.",
  productsBreadcrumbHome: "홈",
  productsBreadcrumbCenter: "제품",
  productsEmpty: "이 카테고리의 제품은 곧 출시됩니다.",
  productsQuoteTitle: "솔루션 및 견적 요청",
  productsQuoteDesc: "응용 시나리오와 생산 능력 요구를 알려주시면 적합한 장비 솔루션을 추천해 드립니다.",
  productsContact: "문의하기",
  aboutHeroTitle: "Yongyuan 소개",
  aboutHeroDesc: "UV 인쇄 장비 연구개발 및 생산에 17년 집중",
  productA23Subtitle: "데스크톱 6색 지능형 UV 프린터",
  productA23Feature1: "A4 인쇄 포맷",
  productA23Feature2: "지능형 잉크 공급 시스템",
  productA23Feature3: "적외선 자동 높이 감지",
  productA35Subtitle: "데스크톱 6색 지능형 UV 프린터",
  productA35Feature1: "A3+ 인쇄 포맷",
  productA35Feature2: "지능형 잉크 공급 시스템",
  productA35Feature3: "적외선 자동 높이 감지",
  productA43Subtitle: "플래그십 8색 지능형 UV 프린터",
  productA43Feature1: "A3 인쇄 포맷",
  productA43Feature2: "다양한 프린트헤드 구성",
  productA43Feature3: "지능형 잉크 공급 시스템",
  productA46Subtitle: "플래그십 8색 지능형 UV 프린터",
  productA46Feature1: "A2 인쇄 포맷",
  productA46Feature2: "다양한 프린트헤드 구성",
  productA46Feature3: "지능형 잉크 공급 시스템",
  productA57Subtitle: "플래그십 8색 지능형 UV 프린터",
  productA57Feature1: "A2+ 인쇄 포맷",
  productA57Feature2: "다양한 프린트헤드 구성",
  productA57Feature3: "지능형 잉크 공급 시스템",
  productA69Subtitle: "플래그십 8색 지능형 UV 프린터",
  productA69Feature1: "A1 인쇄 포맷",
  productA69Feature2: "다양한 프린트헤드 구성",
  productA69Feature3: "지능형 잉크 공급 시스템",
  productA1216Subtitle: "플래그십 대형 UV 플랫베드 프린터",
  productA1216Feature1: "1200×1600cm 인쇄 포맷",
  productA1216Feature2: "다양한 프린트헤드 구성",
  productA1216Feature3: "비전 위치 시스템",
  productA2513Subtitle: "플래그십 대형 UV 플랫베드 프린터",
  productA2513Feature1: "2500×1300cm 인쇄 포맷",
  productA2513Feature2: "다양한 프린트헤드 구성",
  productA2513Feature3: "비전 위치 시스템",
  productCylinderElfSubtitle: "360° 고속 원통형 프린터",
  productCylinderElfFeature1: "360° 인쇄",
  productCylinderElfFeature2: "컵 및 보틀 맞춤 제작",
  productCylinderElfFeature3: "빠른 지그 교체",
  productCupPlusSubtitle: "다양한 크기 컵 및 보틀 인쇄 솔루션",
  productCupPlusFeature1: "다양한 크기 지그",
  productCupPlusFeature2: "높은 생산 효율",
  productCupPlusFeature3: "안정적인 출력",
  productCrystal60Subtitle: "크리스탈 라벨 인쇄 및 포일 일체형 시스템",
  productCrystal60Feature1: "60cm 폭",
  productCrystal60Feature2: "인쇄 및 포일 통합",
  productCrystal60Feature3: "효율적인 수취 시스템",
  productCrystalC60UltraFeature1: "60cm 폭",
  productCrystalC60UltraFeature2: "금박/은박/3D 실리콘 라벨 다양한 솔루션",
  productCrystalC60UltraFeature3: "대량 생산",
  productCrystal30Subtitle: "소형 고정밀 크리스탈 라벨 프린터",
  productCrystal30Feature1: "소형 정밀 인쇄",
  productCrystal30Feature2: "쉬운 조작",
  productCrystal30Feature3: "개인 맞춤 제작",
  productDtf60Subtitle: "화이트 잉크 DTF 전사 프린터",
  productDtf60Feature1: "화이트 잉크 DTF 전사",
  productDtf60Feature2: "풍부한 색상 레이어",
  productDtf60Feature3: "의류 액세서리",
  productDtfF20Subtitle: "업계 최소 데스크톱 화이트 잉크 DTF 프린터",
  productDtfF20Feature1: "A4 크기",
  productDtfF20Feature2: "소량 맞춤 제작",
  productDtfF20Feature3: "스마트 잉크 시스템",
  productDtfF30Subtitle: "데스크톱 화이트 잉크 DTF 프린터",
  productDtfF30Feature1: "A3 크기",
  productDtfF30Feature2: "싱글 헤드 수동/자동 버전 선택",
  productDtfF30Feature3: "스마트 잉크 시스템",
  productDtfF30ProSubtitle: "화이트 잉크 DTF 프린터",
  productDtfF30ProFeature1: "A3 크기",
  productDtfF30ProFeature2: "듀얼 헤드 자동 필름 수납",
  productDtfF30ProFeature3: "스마트 잉크 시스템",
  productDtfF33Subtitle: "화이트 잉크 DTF 프린터",
  productDtfF33Feature1: "A3 크기",
  productDtfF33Feature2: "싱글 헤드 수동/자동 버전 선택",
  productDtfF33Feature3: "스마트 잉크 시스템",
  productDtfF70ProSubtitle: "70cm 와이드 포맷 화이트 잉크 DTF 프린터",
  productDtfF70ProFeature1: "A2 크기",
  productDtfF70ProFeature2: "2–4 헤드 옵션",
  productDtfF70ProFeature3: "자동 급지·배출 시스템",
  productDtfF70ProFeature4: "스마트 인쇄 재개 모드",
  productDtf30Subtitle: "소형 화이트 잉크 DTF 프린터",
  productDtf30Feature1: "소량 맞춤 제작",
  productDtf30Feature2: "정확한 색상 재현",
  productDtf30Feature3: "사용하기 쉬움",
  productDtgPrintSubtitle: "디지털 직접 의류 인쇄 프린터",
  productDtgPrintFeature1: "다재질 직접 인쇄",
  productDtgPrintFeature2: "높은 처리량",
  productDtgPrintFeature3: "안정적이고 내구성 있음",
  productDtg3250DSubtitle: "업계 유일 DTF & DTG 2-in-1 모델",
  productDtg3250DFeature1: "A3+ 폭",
  productDtg3250DFeature2: "DTF & DTG 듀얼 공정 인쇄",
  productDtg3250DFeature3: "스마트 잉크 시스템",
  productDtg3646TSubtitle: "듀얼 스테이션 DTG 프린터",
  productDtg3646TFeature1: "연속 생산 모드",
  productDtg3646TFeature2: "생산 효율 100% 향상",
  productDtg3646TFeature3: "스마트 잉크 시스템",
  productDtgMaxSubtitle: "산업용 디지털 DTG 프린터",
  productDtgMaxFeature1: "산업용 생산 능력",
  productDtgMaxFeature2: "안정적이고 내구성 있음",
  productDtgMaxFeature3: "연속 작업",
  app01Title: "휴대폰 케이스",
  app02Title: "골프공",
  app03Title: "석재 명판",
  app04Title: "볼펜",
  app05Title: "안경 케이스",
  app06Title: "목판화",
  app07Title: "음료 캔",
  app08Title: "키보드",
  app09Title: "텀블러",
  app10Title: "여행 가방",
  app11Title: "아크릴 제품",
  app12Title: "노트북",
  app13Title: "배지",
  app14Title: "가죽 카드 홀더",
  app15Title: "인식표",
  app16Title: "유리 예술",
  appDtgCase01: "티셔츠",
  appDtgCase02: "후드티",
  regionCn: "중국",
  regionUs: "미국",
  regionGb: "영국",
  regionDe: "독일",
  regionAe: "아랍에미리트",
  regionIn: "인도",
  regionJp: "일본",
  regionVn: "베트남",
  regionBr: "브라질",
  regionAu: "호주",

  // synced from en
    uiClose: "Close",
    carouselPrev: "Previous product",
    carouselNext: "Next product",
    heroSlidePrev: "Previous slide",
    heroSlideNext: "Next slide",
    heroSlideDot: "Go to slide {n}",
    customerStoriesTrustedTitle: "Trusted Worldwide",
    customerStoriesBadge: "{count} international customer photos showcased",
    customerStoryCountryUsaNewYork: "New York, USA",
    customerStoryCountryGermany: "Germany",
    customerStoryCountryThailand: "Thailand",
    customerStoryCountrySpain: "Spain",
    customerStoryCountryBrazil: "Brazil",
    customerStoryCountryAustralia: "Australia",
    customerStoryCountrySaudiArabia: "Saudi Arabia",
    customerStoryCountrySingapore: "Singapore",
    customerStoryCountryKorea: "South Korea",
    customerStoryCountryIsrael: "Israel",
    customerStoryCountryKazakhstan: "Kazakhstan",
    customerStoryCountryMexico: "Mexico",
    customerStoryCountryArgentina: "Argentina",
    customerStoryCountryPhilippines: "Philippines",
    customerStoryCountryIndonesia: "Indonesia",
    customerStoryCountryNetherlands: "Netherlands",
    customerStoryCountrySweden: "Sweden",
    customerStoryCountrySouthAfrica: "South Africa",
    customerStoryCountryMalaysia: "Malaysia",
    customerStoryCountryTaiwan: "Taiwan",
    customerStoryCountryUsa: "United States",
    customerStoryCaption01: "USA�?090 UV Printer",
    customerStoryCaption02: "Germany｜F33 DTF Printer",
    customerStoryCaption03: "Thailand�?250 UV Printer",
    customerStoryCaption04: "Spain�?250 UV Printer",
    customerStoryCaption05: "Brazil�?030 UV Printer",
    customerStoryCaption06: "Australia｜F33 DTF Printer",
    customerStoryCaption07: "Saudi Arabia�?030 UV Printer",
    customerStoryCaption08: "Singapore｜F33 DTF Printer",
    customerStoryCaption09: "South Korea｜F33 DTF Printer",
    customerStoryCaption10: "Israel｜UVC33 DTF Printer",
    customerStoryCaption11: "Kazakhstan�?030 UV Printer",
    customerStoryCaption12: "Mexico�?060 UV Printer",
    customerStoryCaption13: "Argentina�?060 UV Printer",
    customerStoryCaption14: "Philippines�?090 UV Printer",
    customerStoryCaption15: "Indonesia�?030 UV Printer",
    customerStoryCaption16: "Netherlands�?030 UV Printer",
    customerStoryCaption17: "Sweden�?060 UV Printer",
    customerStoryCaption18: "Germany�?030 UV Printer",
    customerStoryCaption19: "South Africa�?030 UV Printer",
    customerStoryCaption20: "Malaysia｜F33 DTF Printer",
    customerStoryCaption21: "Taiwan｜UVC33 DTF Printer",
    customerStoryCaption22: "USA｜F70Pro DTF Printer",
    customerStoryCaption23: "USA�?513 UV Printer",
    customerStoryCaption24: "USA�?090 UV Printer",
    customerStoryCaption25: "USA�?030 UV Printer",
    customerStoryCaption26: "USA�?250 UV Printer",
    customerStoryCaption27: "South Korea�?060 UV Printer",
    customerStoryCaption28: "Netherlands�?060 UV Printer",
    catUvNav: "UV Flatbed",
    catCylinderNav: "Cylindrical",
    catCrystalNav: "Crystal Label",
    catDtfNav: "DTF",
    catDtgNav: "DTG",
    productA3220Subtitle: "Ultra Wide-Format Industrial UV Flatbed Solution",
    productA3220Feature1: "320×200cm Print Format",
    productA3220Feature2: "Visual Positioning System",
    productA3220Feature3: "Continuous Batch Production",
    productCrystal60UltraSubtitle: "Flagship Crystal Label Printing Solution",
    cityShanghai: "Shanghai",
    cityShenzhen: "Shenzhen",
    cityDetroit: "Detroit",
    cityManchester: "Manchester",
    cityStuttgart: "Stuttgart",
    cityDubai: "Dubai",
    cityPune: "Pune",
    cityOsaka: "Osaka",
    cityHoChiMinh: "Ho Chi Minh City",
    citySaoPaulo: "São Paulo",
    cityMelbourne: "Melbourne",
};
